'use client'

import React from 'react';
import Script from 'next/script';

export const ScriptForBlind = () => {
  return (
    <>
      <Script
        id={'script-for-blind-jquery'}
        src={'/scripts/jquery.js'}
        strategy={'afterInteractive'}
      ></Script>
      <Script
        id={'script-for-blind'}
        src={'/scripts/blind-mode.js'}
        strategy={'afterInteractive'}
      ></Script>
    </>
  );
};
